import React, { FC, Fragment } from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { useStyles } from "../../useStyles";
import { ChangeNames, ChangeTypes } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

const convertValue = (
    value: ChangeTypes[ChangeNames.NEW_CONNECTION_POWER_FEEDS]["value"],
): string => {
    if (value.exterior) {
        return "exterior";
    } else if (value.interior) {
        return "interior";
    } else if (value.overhead) {
        return "overhead";
    }
    return "";
};

export const NewConnectionPowerFeedsForm: FC = () => {
    const { values, setValues, submitChange } = useFormModel<
        ChangeNames.NEW_CONNECTION_POWER_FEEDS
    >();
    const classes = useStyles();
    const selection = convertValue(values.newConnectionPowerFeeds.value);
    return (
        <Fragment>
            <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                Gewünschte Ausführungsvariante für Strom
            </h4>
            <FormControl
                component="fieldset"
                className={classes.container}
                style={{ display: "flex" }}
            >
                <RadioGroup
                    value={selection}
                    onChange={(e, v) => {
                        const newValues = setValues(values => {
                            values.newConnectionPowerFeeds.value.exterior =
                                v.indexOf("exterior") >= 0;
                            values.newConnectionPowerFeeds.value.interior =
                                v.indexOf("interior") >= 0;
                            values.newConnectionPowerFeeds.value.overhead =
                                v.indexOf("overhead") >= 0;
                        });
                        submitChange(newValues);
                    }}
                >
                    <FormControlLabel
                        value="interior"
                        control={<Radio />}
                        label="Innenanschluss"
                        text="Hier erfolgt der Netzanschluss in der Regel durch die Kelleraußenwand, oder durch die Bodenplatte in das Gebäude."
                        error={values.newConnectionPowerFeeds.error !== null}
                    />
                    <FormControlLabel
                        value="exterior"
                        control={<Radio />}
                        label="Außenanschluss"
                        text="Bei der Außenanschlusstechnik wird der Netzanschluss außerhalb des Gebäudes auf Ihrem Grundstück errichtet. Dadurch entfällt der Platzbedarf für den Netzanschluss im Gebäude."
                        error={values.newConnectionPowerFeeds.error !== null}
                    />
                    <FormControlLabel
                        value="overhead"
                        control={<Radio />}
                        label="Freileitung"
                        text="Bei der Freileitungstechnik erfolgt der Netzanschluss über einen Dachständer auf dem Gebäude."
                        error={values.newConnectionPowerFeeds.error !== null}
                    />
                </RadioGroup>
            </FormControl>
        </Fragment>
    );
};
